/*
 * Copyright (c) 2023. Henry Zilek
 */

import {createStore} from "vuex";
import gPost from "@/support/gPost";

const store = createStore(
    {
        strict: false,

        state: {
            apiToken: null,
            apiAuthorization: null,
            apiKey: null,
            dataSettingLoaded: false,
            shopId: null,
            shopLoc: null,
            userName: "",
            userToken: "",
            isAdmin: false,
            showDevInfo: true,
            hoverOverPerson: false,
            refreshInterval: 15 * 60 * 1000,
            baseApiUrl: null,
            baseAdminUrl: null,
            storeRefURL: "",
            webEmail: "notigo@notigo.cz",
            develop: false,
            onlineStatus: null,
            showDictionaryPopup: false,
            dictionaryText: "",
            dictionaryId: "",
            mobileMenuActive: false,
            width: 0,
            height: 0,
            resizeDone: false,
            configList: [],
            curConfigFile: "config.json",
            isConfigModified: false,
            updateConfigList: false,
            listMsg: [],
            gallery: [],
            fabIcons: [],
            sideMenu: [
                {text: "Úvod", name: "Home", type: 'default', hash: "#uvod", fa_icon: ""},
                {text: "Co nabízíme", name: "Home", type: 'default', hash: "#nabidka", fa_icon: ""},
                {text: "Projekty", name: "Home", type: 'default', hash: "#projekty", fa_icon: ""},
                {text: "Poznejte nás", name: "Home", type: 'default', hash: "#oNas", fa_icon: ""},
                {text: "Kontakty", name: "Home", type: 'default', hash: "#kontakt", fa_icon: ""},
            ],
            socialMenu: [
                {
                    text: "+420 724 135 547",
                    name: "tel:+420724135547",
                    target: "_self",
                    type: 'phone',
                    hash: "",
                    fa_icon: "fa-solid fa-phone",
                    button_color: "button-blue"
                },
                {
                    text: "notigo@notigo.cz",
                    name: "mailto:notigo@notigo.cz",
                    target: "_self",
                    type: 'email',
                    hash: "",
                    fa_icon: "fa-solid fa-envelope",
                    button_color: "button-blue"
                },
                {
                    text: "Notigo",
                    name: "https://www.instagram.com/notigo.cz/",
                    target: "_blank",
                    type: 'instagram',
                    hash: "",
                    fa_icon: "fa-brands fa-instagram",
                    button_color: "button-gray"
                },
                {
                    text: "Notigo",
                    name: "https://www.facebook.com/notigo.cz",
                    target: "_blank",
                    type: 'facebook',
                    hash: "",
                    fa_icon: "fa-brands fa-facebook-f",
                    button_color: "button-gray"
                },
                {
                    text: "Notigo Agency",
                    name: "https://www.linkedin.com/company/notigo/",
                    target: "_blank",
                    type: 'linkedin',
                    hash: "",
                    fa_icon: "fa-brands fa-linkedin-in",
                    button_color: "button-gray"
                },
            ],
            categoryList: [
                {id: "1", title: "Tvoříme", style: "text-magenta", color: "magenta", active: true},
                {id: "2", title: "Zviditelňujeme", style: "text-yellow", color: "yellow", active: true},
                {id: "3", title: "Komunikujeme", style: "text-green", color: "green", active: true},
            ],
            shortArticle: [
                {
                    title: "Marketingové strategie",
                    shortText: "Marketingový plán,<br>brand management,<br>výběr komunikačních kanálů",
                    iconName: 'svet',
                    category: "1",
                    fab_icon: "fa-light fa-bolt", itemId: 1, active: true
                },

            ],
            dictionary: [
                {
                    id: 'test',
                    shortText: 'Informace o definici',
                    title: 'Odkaz',
                    text: "Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis Dlouhý popis "
                },
                {
                    id: 'test1',
                    shortText: 'Informace o dalsi definici ktera nam neco rekne definici',
                    title: 'Odkaz na definici',
                    text: "Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis "
                },
                {
                    id: 'test2',
                    shortText: 'Vysvětlení BUBUBUBU',
                    title: 'Odkaz na definici BUBUBUBU',
                    text: "BUBUBUBU Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis "
                },
                {
                    id: 'test3',
                    shortText: 'Vysvětlení Odkazu nekam',
                    title: 'Je to nekam',
                    text: "BUBUBUBU Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis Ještě delší popis "
                },

            ],
            customerLogo: [
                {logoName: "custLogo/logo_anezka.webp", itemId: 1, url: "https://anezkapraha.cz/", active: true},
                {
                    logoName: "custLogo/projekty_logo_autoseu.webp",
                    itemId: 2,
                    url: "https://www.autoseu.com/",
                    active: true
                },
                {logoName: "custLogo/projekty_logo_coffeenek.webp", itemId: 3, url: "", active: true},


            ],
            // customerDetails: [
            //     {
            //         itemId: 1,
            //         image: "01-notigo-230710-mockupy-uvod-male-patric.png",
            //         logo: "custLogo/logo_dua.webp",
            //         title: "PATRIC",
            //         serviceType: ["Web", "Sociální sítě"],
            //         color: "blue",
            //         url: "https://www.patric.cz/"
            //
            //     },
            //     {
            //         itemId: 2,
            //         image: "mockup_dua.webp",
            //         logo: "custLogo/logo_dua.webp",
            //         title: "Dům u Agáty",
            //         serviceType: ["Web", "SEO", "PR"],
            //         color: "orange",
            //         url: "https://www.dumuagaty.cz/"
            //     },
            // ],

            customerDetails:[
                {
                    itemId: 1,
                    image: "01-notigo-230710-mockupy-uvod-male-patric.png",
                    logo: "",
                    title: "PATRIC",
                    serviceType: ["Web", "Sociální sítě"],
                    color: "grey",
                    url: "https://www.patric.cz/"
                },
                {
                    itemId: 1,
                    image: "03-notigo-230710-mockupy-uvod-male-autoseu.png",
                    logo: "custLogo/logo_dua.webp",
                    title: "AutosEU",
                    serviceType: ["Vizuální identita", "Strategie"],
                    color: "grey",
                    url: "https://www.autos.eu/"
                },
                {
                    itemId: 1,
                    image: "06-notigo-230710-mockupy-uvod-male-dalsimisto.png",
                    logo: "custLogo/logo_dua.webp",
                    title: "Další Místo",
                    serviceType: ["Vizuální identita", "Strategie"],
                    color: "grey",
                    url: "https://www.patric.cz/"
                },
                {
                    itemId: 1,
                    image: "07-notigo-230710-mockupy-uvod-male-kuratorky.png",
                    logo: "custLogo/logo_dua.webp",
                    title: "3Kurátorky",
                    serviceType: ["Web", "Video"],
                    color: "grey",
                    url: "https://www.patric.cz/"
                },
                {itemId: 1,image: "05-notigo-230710-mockupy-uvod-male-agata.png", logo: "custLogo/logo_dua.webp", title: "Dům u Agáty", serviceType:["Web", "SEO", "PR"], color:"grey", url:"https://www.dumuagaty.cz/" },
                {itemId: 2,image: "08-notigo-230710-mockupy-uvod-male-insio.png", logo: "custLogo/logo_dua.webp", title: "Insio", serviceType:["Strategie", "Grafika", "Video"], color:"grey", url:"https://anezkapraha.cz/" },
                {itemId: 3,image: "02-notigo-230710-mockupy-uvod-male-dotoho.png", logo: "", title: "DoToho", serviceType:["Animace", "Audio"], color:"grey", url:"https://dotoho.pro/" },
                {itemId: 4,image: "04-notigo-230710-mockupy-uvod-male-wia.png", logo: "custLogo/logo_wia.webp", title: "WIA", serviceType:["Web", "SEO", "Design"], color:"grey", url:"https://optika.wia.cz/" },
            ],
            ourPeople: [
                {
                    itemId: 1,
                    title: "Vrchní čaroděj",
                    name: "Bc. Kryštof Kněžínek",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aliquam erat volutpat. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos hymenaeos.",
                    avatar: "man-real-sq.png",
                    pic: "man-real-sq.png",
                    ico: "fa-solid fa-hat-wizard",
                    active: true
                },
            ]

        },

        mutations: {
            setIsConfigModified(con, newValue) {
                con.isConfigModified = newValue
            },

            setUserToken(con, newValue) {
                con.userToken = newValue
            },

            setUpdateConfigList(con, newValue) {
                con.updateConfigList = newValue
            },

            setResizeDone(con, newValue) {
                con.resizeDone = newValue
            },

            setCurConfigFile(con, newValue) {
                con.curConfigFile = newValue
            },

            setShowDevInfo(con, newValue) {
                con.showDevInfo = newValue
            },

            setHoverOverPerson(con, newValue) {
                con.hoverOverPerson = newValue
            },

            setNewMsg(cur, newValue) {
                cur.listMsg.push({msg: newValue.msg, msgType: newValue.msgType});
            },

            removeMsg(cur) {
                cur.listMsg.shift();
            },

            setFabIcons(con, newValue) {
                con.fabIcons = newValue;
            },

            setDataSettingLoaded(con, newValue) {
                con.dataSettingLoaded = newValue;
            },

            setOurPeople(con, newValue) {
                con.ourPeople = [...newValue];
            },

            setCustomerLogo(con, newValue) {
                con.customerLogo = [...newValue];
            },

            setCustomerDetails(con, newValue) {
                con.customerDetails = [...newValue];
            },

            setCategory(con, newValue) {
                con.categoryList = [...newValue];
            },

            setShortArticle(con, newValue) {
                con.shortArticle = [...newValue];
            },

            setUserName(con, newValue) {
                con.userName = newValue;
            },

            setIsAdmin(con, newValue) {
                con.isAdmin = newValue;
            },

            setGallery(con, newValue) {
                con.gallery = newValue;
            },

            setConfigList(con, newValue) {
                con.configList = newValue;
            },

            setWidth(con, newValue) {
                con.width = newValue;
            },

            setHeight(con, newValue) {
                con.height = newValue;
            },

            setMobileMenuActiveStatus(con, newValue) {
                con.mobileMenuActive = newValue;
            },

            setApiKey(con, newValue) {
                con.apiKey = newValue;
            },

            setApiAuthorization(con, newValue) {
                con.apiAuthorization = newValue;
            },
            setApiToken(con, newValue) {
                con.apiToken = newValue;
            },
            setDevelopStatus(con, newValue) {
                con.develop = newValue;
            },
            setBaseApiUrl(con, newValue) {
                con.baseApiUrl = newValue;
            },
            setBaseAdminUrl(con, newValue) {
                con.baseAdminUrl = newValue;
            },
            setShopId(con, newValue) {
                con.shopId = newValue;
            },
            setShopLoc(con, newValue) {
                con.shopLoc = newValue;
            },
            setStoreUrl(cur, newValue) {
                cur.storeRefURL = newValue;
            },
            setRefreshInterval(con, newValue) {
                con.refreshInterval = newValue * 60 * 1000;
            },
            setOnlineStatus(con, newValue) {
                con.onlineStatus = newValue;
            },
            setShowDictionaryPopup(con, newValue) {
                con.showDictionaryPopup = newValue;
            },
            setDictionaryText(con, newValue) {
                con.dictionaryText = newValue;
            },
            setDictionaryId(con, newValue) {
                con.dictionaryId = newValue;
            },

        },

        actions: {
            watchOnlineStatus(con) {
                con.commit('setOnlineStatus', navigator.onLine ? "online" : "offline");

                window.addEventListener('offline', () => {
                    con.commit('setOnlineStatus', 'offline');
                });
                window.addEventListener('online', () => {
                    con.commit('setOnlineStatus', 'online');
                });
            },

            setUser(con, data) {
                con.commit('setUserName', data.user);
                con.commit('setIsAdmin', data.isAdmin);
                con.commit('setUserToken', data.userToken);

            },

            clearUser(con) {
                con.commit('setIsAdmin', false);
                con.commit('setUserName', "");

            },

            getConfigList(con) {
                let param = {
                    task: "getConfigList"
                };

                let baseUrl = con.state.baseAdminUrl + "support/configList.php";
                gPost(baseUrl, param,
                    (data) => con.commit('setConfigList', data.configList),
                    null)
            },

            async removeConfigFile(con, fileName) {
                let param = {
                    task: "removeConfigFile",
                    fileName: fileName
                };

                let baseUrl = con.state.baseAdminUrl + "support/configList.php";

                await gPost(baseUrl, param,
                    (data) => con.commit('setConfigList', data.configList),
                    (err) => {
                        this.message = "Could not received config list! " + err;
                    }
                )
            },

            getGallery(con) {
                console.log("In GetGallery");
                let param = {
                    task: "getGallery"
                };

                let baseUrl = con.state.baseAdminUrl + "support/galleryListDir.php";

                gPost(baseUrl, param,
                    (data) => con.commit('setGallery', data.galleryList),
                    (err) => {
                        this.progress = 0;
                        this.message = "Could not received gallery list! " + err;
                        this.currentImage = undefined;
                    }
                )


            },

            async getSetting(con, configFile) {
                let baseAdminUrl = null
                await fetch(process.env.BASE_URL + "config.json")
                    .then((response) => {
                        return response.json();
                    })
                    .then((config) => {
                        baseAdminUrl = window.location.origin.includes("localhost") ? config.baseAdminUrl : window.location.origin + "/";
                    })

                await fetch(baseAdminUrl + "support/" + configFile + "?mark", {})
                    .then((response) => {
                        return response.json();
                    })
                    .then((config) => {
                        console.log("Reading config file")
                        if (config.fabIcons) {
                            console.log("Reading fabIcons")
                            con.commit('setFabIcons', JSON.parse(config.fabIcons));
                        }
                        if (config.ourPeople) {
                            console.log("Reading ourPeople")
                            con.commit('setOurPeople', JSON.parse(config.ourPeople));
                        }
                        if (config.customerLogo) {
                            console.log("Reading customerLogo")
                            con.commit('setCustomerLogo', JSON.parse(config.customerLogo));
                        }
//                        if (config.customerDetails) { // TODO Blocked Customer details. Fix later if needed
//                             console.log("Reading customerDetails")
//                             con.commit('setCustomerDetails', JSON.parse(config.customerDetails));
//                         }
                        if (config.category) {
                            console.log("Reading category")
                            con.commit('setCategory', JSON.parse(config.category));
                        }
                        if (config.shortArticle) {
                            console.log("Reading shortArticle")
                            con.commit('setShortArticle', JSON.parse(config.shortArticle));
                        }
                    }).then(() => {
                        console.log("Vse nahrano " + con.state.customerLogo.length)
                        con.commit('setDataSettingLoaded', true)
                    })

            },

            storeConfigUpdate(con) {

                let baseUrl = con.state.baseAdminUrl + "support/updateSetting.php";
                con.dispatch('storeUpdate', baseUrl)

            },

            storeBackConfigUpdate(con) {

                let baseUrl = con.state.baseAdminUrl + "support/backupTmpSetting.php";
                con.dispatch('storeUpdate', baseUrl)

            },

            storeUpdate(con, baseUrl) {
                let param = {
                    task: "storeUpdate",
                    curConfigAdminFile: con.state.curConfigFile,
                    data: {
                        gallery: JSON.stringify(con.state.gallery),
                        category: JSON.stringify(con.state.categoryList),
                        fabIcons: JSON.stringify(con.state.fabIcons),
                        shortArticle: JSON.stringify(con.state.shortArticle),
                        ourPeople: JSON.stringify(con.state.ourPeople),
                        customerDetails: JSON.stringify(con.state.customerDetails),
                        customerLogo: JSON.stringify(con.state.customerLogo),
                    }
                };

                gPost(baseUrl, param,
                    (data) => {
                        if (data.isNewSetting) {
                            con.commit('setNewMsg', {msg: "Záloha nastavení uložena"});
                        }
                        if (data.isModified !== null) {
                            con.commit('setIsConfigModified', data.isModified);
                        }
                        con.commit('setNewMsg', {msg: "Nastavení uloženo"});
                        con.commit('setCurConfigFile', data.curConfig);
                        con.dispatch('getConfigList')
                            .then(() => con.commit('setUpdateConfigList', true));
                    },
                    () => {
                        con.commit('setNewMsg', {msg: "Problém s uložením nastavení", msgType: "alert_msg"});

                    }
                )
            }

        },

        getters: {
            getOnlineStatus(state) {
                return state.onlineStatus;
            },

            viewPortSize(state) {
                return state.width + " x " + state.height;
            },

            isTablet(state) {
                return state.width > 480 && state.width < 860;
            },

            isMobile(state) {
                return state.width <= 480;
            },


            isResizeDone(state) {
                return state.resizeDone
            },

            getUpdateConfigListStatus(state) {
                return state.updateConfigList
            }
        },


    }
)

export default store;